import * as React from 'react'
import { LeadBulkActionFooter } from './LeadBulkActionFooter'
import { LeadBulkDelete } from './LeadBulkDelete'
import {
  BulkActions,
  BulkReopenButton,
  BulkReassignButton,
  BulkUpdateStatusButton,
  BulkAddActivityButton,
} from '@user/components/xGrid'
import { useCheckBulkPermissions } from '@user/store/authorization/hooks'
import { LeadBulkUpdateNextActionDate } from './LeadBulkUpdateNextActionDate'
import Stack from '@mui/material/Stack'
import { LeadBulkAddNote } from './LeadBulkAddNote'

export const LeadBulkActions: BulkActions = (props) => {
  const { hasUpdatePermission, hasDeletePermission } =
    useCheckBulkPermissions('leads')

  return (
    // eslint-disable-next-line react/jsx-no-undef
    <>
      <Stack direction="row" gap={1} flexWrap="wrap">
        <BulkUpdateStatusButton hasPermission={hasUpdatePermission} />
        <BulkReopenButton hasPermission={hasUpdatePermission} />
        <BulkReassignButton hasPermission={hasUpdatePermission} />
        <LeadBulkDelete {...props} hasPermission={hasDeletePermission} />
        <LeadBulkUpdateNextActionDate
          {...props}
          hasPermission={hasUpdatePermission}
        />
        <BulkAddActivityButton hasPermission={true} />
        <LeadBulkAddNote {...props} hasPermission={hasUpdatePermission} />
      </Stack>
      <LeadBulkActionFooter {...props} />
    </>
  )
}
LeadBulkActions.displayName = 'LeadBulkActions'
